<script setup>
const props = defineProps({
  name: { type: String, required: true },
  label: { type: String, required: true },
  value: { type: Boolean, required: false },
  errorMessage: { type: String, required: false },
});

const emit = defineEmits(['update:value', 'input']);

function onChange(e) {
  emit('update:value', e.target.checked);
  emit('input', e.target.checked);
}
</script>

<template>
  <label
    :for="`checkbox--${props.name}`"
    class="label"
  >
    <input
      type="checkbox"
      :id="`checkbox--${props.name}`"
      :name="`checkbox--${props.name}`"
      :checked="props.value"
      ref="checkbox"
      @change="onChange"
    />
    <span class="box" :class="props.errorMessage && 'error'" />
    {{ props.label }}
    <small
      v-if="props.errorMessage"
      class="error-msg">
      {{ props.errorMessage }}
    </small>
  </label>
</template>

<style lang="scss" scoped>
label {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  cursor: pointer;
}

input {
  position: absolute;
  opacity: 0;

  &:checked {
    & + .box {
      &::after {
        display: block;
      }
    }
  }
}

.box {
  height: 24px;
  width: 24px;
  border: 2px solid #cdcdcd;
  border-radius: 4px;

  &::after {
    content: '';
    position: absolute;
    left: 8px;
    top: 3px;
    width: 8px;
    height: 14px;
    border: solid #000;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    display: none;
  }

  &.error {
    border-color: $AC_Primary;
  }
}

.error-msg {
  display: block;
  color: $AC_Primary;
  position: absolute;
  left: 30px;
  bottom: -20px;
}
</style>
